<template>
  <div class="h-dialogContainer">
    <div class='col-sm-4'>
      <ServerDetailLeft :detailShow="detailShow" :detailInfo="detailInfo" :buttonShow="deployFlag"></ServerDetailLeft>
    </div>
    <div class='col-sm-8'>
      <ejs-tab ref='deployedTab' heightAdjustMode='heightAdjustMode' cssClass='tabsClass'>
        <div class="e-tab-header h-subscriber-subTabs-header">
          <div v-for="item of headers" :key="item.key">{{item.text}}</div>
        </div>
        <div class="e-content h-subscriber-subTabs-content">
          <div id='deployed' class="h-subscribe-height-415">
            <ejs-treegrid :dataSource="data" :treeColumnIndex='1' :allowSorting='true'
                          childMapping='subtasks'>
              <e-columns>
                <e-column field='taskID' headerText='Task ID' textAlign='Right' width=90 :visible='false'></e-column>
                <e-column field='taskName' headerText='Task Name' textAlign='Left' width=180></e-column>
                <e-column field='startDate' headerText='Start Date' textAlign='Right' format='yMd' width=90></e-column>
                <e-column field='duration' headerText='Duration' textAlign='Right' width=80></e-column>
              </e-columns>
            </ejs-treegrid>
          </div>
        </div>
      </ejs-tab>
    </div>
  </div>
</template>

<script>
import ServerDetailLeft from '../ServerDetailLeft';

export default {
  name: 'DeployedDetailDialog',
  components: {
    ServerDetailLeft
  },
  data() {
    return {
      headers: [
        { text: '部署', iconCss: 'tabsClass', key: 'deployed' }
      ],
      data: [{
        taskID: 1,
        taskName: 'Planning',
        startDate: new Date('02/03/2017'),
        endDate: new Date('02/07/2017'),
        progress: 100,
        duration: 5,
        priority: 'Normal',
        approved: false,
        // subtasks: [
        //   { taskID: 2, taskName: 'Plan timeline', startDate: new Date('02/03/2017'), endDate: new Date('02/07/2017'), duration: 5, progress: 100, priority: 'Normal', approved: false },
        //   { taskID: 3, taskName: 'Plan budget', startDate: new Date('02/03/2017'), endDate: new Date('02/07/2017'), duration: 5, progress: 100, approved: true },
        //   { taskID: 4, taskName: 'Allocate resources', startDate: new Date('02/03/2017'), endDate: new Date('02/07/2017'), duration: 5, progress: 100, priority: 'Critical', approved: false },
        //   { taskID: 5, taskName: 'Planning complete', startDate: new Date('02/07/2017'), endDate: new Date('02/07/2017'), duration: 0, progress: 0, priority: 'Low', approved: true }
        // ]
      },
      {
        taskID: 6,
        taskName: 'Design',
        startDate: new Date('02/10/2017'),
        endDate: new Date('02/14/2017'),
        duration: 3,
        progress: 86,
        priority: 'High',
        approved: false,
        // subtasks: [
        //   { taskID: 7, taskName: 'Software Specification', startDate: new Date('02/10/2017'), endDate: new Date('02/12/2017'), duration: 3, progress: 60, priority: 'Normal', approved: false },
        //   { taskID: 8, taskName: 'Develop prototype', startDate: new Date('02/10/2017'), endDate: new Date('02/12/2017'), duration: 3, progress: 100, priority: 'Critical', approved: false },
        //   { taskID: 9, taskName: 'Get approval from customer', startDate: new Date('02/13/2017'), endDate: new Date('02/14/2017'), duration: 2, progress: 100, approved: true },
        //   { taskID: 10, taskName: 'Design Documentation', startDate: new Date('02/13/2017'), endDate: new Date('02/14/2017'), duration: 2, progress: 100, approved: true },
        //   { taskID: 11, taskName: 'Design complete', startDate: new Date('02/14/2017'), endDate: new Date('02/14/2017'), duration: 0, progress: 0, priority: 'Normal', approved: true }
        // ]
      }],
    };
  }
};
</script>

<style scoped>

</style>
